import { call, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '../../APIs/common/service-locator';
import { receiveSSNsFailure, receiveSSNsSuccess, updateSSNs } from '../../actions/ssap/ssapActionCreators';
import { differenceBy } from '../../utils/miscellaneous/objectHelpers';

export function* receiveSsnsSaga(action) {
    try {
        const {
            guids,
            payload,
            toggleExtraDataStatus,
            togglePageReadiness
        } = action;

        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const response = yield call([ ssapService, ssapService.receiveSSNs ], payload);

        if(response && differenceBy(response, guids, 'applicantGuid').length === 0) {
            yield put(updateSSNs(response));
            yield call(toggleExtraDataStatus, true);
            yield call(togglePageReadiness, true);
            yield put(receiveSSNsSuccess());
        } else {
            const { console, console: { error } } = global;
            yield call(
                [console, error],
                'SSNs either not received from Back-End or Back-End response does not match existing applicants GUIDs'
            );
            yield put(receiveSSNsFailure());
        }
    } catch(e) {
        yield put(receiveSSNsFailure());
    }
}